import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PageContent } from 'components';
import { checkPermissions, isLoading, globalPropTypes } from 'helpers';
import { useAccessGuard } from 'hooks';
import {
  loadYcGlobalEventFormCreator,
  removeYcGlobalEventFormCreator,
  saveYcGlobalEventCreator,
  setYcGlobalEventErrorsCreator,
} from 'store/actionsCreators';
import GlobalEventForm from '../Form/GlobalEventForm';

/** A new record of which Young Crews attended one global event. */
const AddGlobalEvent = ({
  form,
  errors,
  loading,
  userPermissions,
  loadForm,
  clearForm,
  saveEntry,
  clearErrors,
}) => {
  const [allowed, renderAccessDeniedModal] = useAccessGuard(
    checkPermissions({ roles: ['ipma_yc_global_events_manage'] }, userPermissions || []),
    '/ipma/global-events',
    'page.ipma.globalEvents.accessDenied',
  );

  useEffect(() => {
    if (!allowed) return undefined;

    loadForm();

    // The next screen picks up its own options; leaving these behind would
    // show the previous entry for as long as the request takes.
    return () => clearForm();
  }, [allowed]);

  if (!allowed) {
    return <PageContent>{renderAccessDeniedModal()}</PageContent>;
  }

  return (
    <GlobalEventForm
      mode="create"
      options={form}
      errors={errors}
      loading={loading}
      onSave={saveEntry}
      clearErrors={clearErrors}
    />
  );
};

AddGlobalEvent.propTypes = {
  form: PropTypes.shape({
    eventOptions: PropTypes.arrayOf(PropTypes.shape({})),
    youngCrewOptions: PropTypes.arrayOf(PropTypes.shape({})),
    yearOptions: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  loading: PropTypes.bool.isRequired,
  userPermissions: globalPropTypes.UserPermissions.isRequired,
  loadForm: PropTypes.func.isRequired,
  clearForm: PropTypes.func.isRequired,
  saveEntry: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
};

const mapStateToProps = ({ ipma, user, loading }) => ({
  form: ipma.ycGlobalEvents.form,
  errors: ipma.ycGlobalEvents.errors,
  loading: isLoading(loading, 'GLOBAL'),
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadForm: () => dispatch(loadYcGlobalEventFormCreator()),
  clearForm: () => dispatch(removeYcGlobalEventFormCreator()),
  saveEntry: (payload, history) => dispatch(saveYcGlobalEventCreator(payload, history)),
  clearErrors: () => dispatch(setYcGlobalEventErrorsCreator({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddGlobalEvent);
